import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

const Root = styled.div`
  margin: 20px 0 10px;
  padding: 30px 20px;
  background: ${theme.colors.neutral[100]};
`;

const SelfieUploaderSuccess = () => {
  return (
    <Root>
      <Typography align="center" variant="p3">
        Thanks! Your selfies have been successfully uploaded.
      </Typography>
    </Root>
  );
};

export default SelfieUploaderSuccess;
